import { useSelector } from 'react-redux';
import { selectCrmOrgsMap } from '../../components/pages/environments/environmentsReducer';
import useFetchCrmOrgObjectTypes from './useFetchCrmOrgObjectTypes';

export const useGetObjectTypesLabel = () => {
  const crmOrgsMap = useSelector(selectCrmOrgsMap);
  const fetchCrmOrgObjectTypes = useFetchCrmOrgObjectTypes();

  const getObjectTypeLabel = (crmOrgId: string, objectName: string) => {
    if (!crmOrgsMap[crmOrgId]) {
      fetchCrmOrgObjectTypes({ crmOrgId });
    }

    return (
      crmOrgsMap[crmOrgId]?.objectTypes?.find((ot) => ot.objectType === objectName)?.label ??
      objectName
    );
  };

  return {
    getObjectTypeLabel,
  };
};
